import script from "./SunburstChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SunburstChart.vue?vue&type=script&setup=true&lang=js"

import "./SunburstChart.vue?vue&type=style&index=0&id=d2d1c470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2d1c470"]])

export default __exports__